<template>
  <div class="flex flex-col h-[520px] pl-4 xl:px-0 xl:h-[712px]"
       :class="{ '!h-auto xl:!h-auto': additional }">

    <div v-if="commentaryData.commentaryPlanned && !additional"
         class="w-[calc(100%_+_1rem)] h-[40px] shrink-0 bg-zt-light-full mb-4 -ml-4 pl-2 pr-4 flex justify-between items-center
                xl:w-auto xl:ml-12 xl:mr-12 xl:rounded-zt">
      <span class="text-zt-more text-xs font-medium" :class="{ 'opacity-40': commentaryData.status !== 'IP' }">
        Powiadom o nowych komentarzach w relacji
      </span>
      <div class="form-check form-switch inline-block" :class="{ 'opacity-40': commentaryData.status !== 'IP' }"
           data-bs-toggle="tooltip" :title="commentaryData.status !== 'IP' ? 'Powiadomienia tylko w trakcie gali' : ''"
           @click="hideTooltip" data-bs-trigger="click">
        <input class="form-check-input appearance-none w-9 rounded-full float-left h-5 bg-no-repeat border border-gray-400
                      bg-[#1A222D] cursor-pointer shadow-sm focus:outline-none checked:bg-zt-red checked:border-zt-red"
               :class="{ 'pointer-events-none': commentaryData.status !== 'IP' }"
               type="checkbox" role="switch" :checked="commentaryData.soundEnabled"
               :disabled="commentaryData.status !== 'IP'"
               @click="toggleSound(); handleCount();">
      </div>
    </div>

    <div v-if="(!dataLoading && commentaryData.status === 'EN' && keyMomentsCount > 0) && !additional"
         class="border-b border-zt-light/35 flex items-center justify-center h-12 shrink-0 pb-4 mb-2 -ml-4 xl:mx-0">
      <div class="swiper-slide w-fit rounded-zt border-[#2C3A4E] text-xs font-medium px-4 border rounded-r-none
                        xl:w-[145px] xl:h-7  xl:border-zt-light xl:zt-hover xl:px-0
                        flex justify-center items-center cursor-pointer"
           :class="{ 'bg-zt-light !text-white': fullCommentary }"
           @click="() => { fullCommentary = true }">
        PEŁNA RELACJA
      </div>
      <div class="swiper-slide w-fit rounded-zt border-[#2C3A4E] text-xs font-medium px-4 border rounded-l-none
                        xl:w-[145px] xl:h-7 xl:border-zt-light xl:px-0
                        flex justify-center items-center"
           :class="[{ 'bg-zt-light !text-white': !fullCommentary }, additional ? 'opacity-40 text-zt-more' : 'xl:zt-hover cursor-pointer']"
           @click="() => { if (!additional) fullCommentary = false }">KLUCZOWE MOMENTY</div>
    </div>

    <div v-if="commentaryData.status !== '' && commentaryData.status !== 'NS'"
         class="flex justify-between items-center text-white xl:px-12">
      <span class="text-2xl font-medium">Relacja {{ galaName }}</span>
      <div v-if="commentaryData.status === 'IP'"
           class="bg-[#CE2121] rounded-zt font-semibold px-1 shrink-0 whitespace-nowrap mr-4 xl:mr-0"
           style="box-shadow: 0px 0px 10px 0px #161821;">
        NA ŻYWO
      </div>
    </div>

    <div v-if="!dataLoading && commentaryData.status === 'NS' && commentariesToShow.length === 0 && !additional"
         class="h-[480px] flex flex-col justify-evenly items-center text-center">
      <img class="-mt-6" :src="'/wp-content/themes/zawodtyper/assets/images/commentary_no_messages.svg'"
           width="326" height="197" alt="">
      <div class="flex flex-col items-center font-medium">
        <span>Relacja tekstowa rozpocznie się</span>
        <span class="text-zt-more">{{ getStartDate() }}</span>
      </div>
      <span class="text-sm font-medium">Do czasu rozpoczęcia tego wydarzenia zachęcamy do zapoznania się ze szczegółami dotyczącymi gali!</span>
    </div>

    <div v-show="!dataLoading && commentariesToShow.length > 0"
         class="relative bg-zt-normal flex flex-col rounded-zt h-full min-h-0"
         :class="{ 'xl:pl-[44px]': !additional }">
      <div v-if="commentaryData.status === 'IP' && commentaryData.commentaryPlanned && !additional"
           class="text-white/50 font-light text-sm flex items-center my-4 xl:pl-2">
        Relację śledzi:
        <Transition name="slide-fade" mode="out-in">
          <span class="text-white font-medium mx-1 text-center" :style="{ minWidth: followsNumberWidth }"
                :key="commentaryData.currentlyFollows">
            <span v-if="!isNaN(commentaryData.currentlyFollows)">
              {{ commentaryData.currentlyFollows * 3 }}
            </span>
            <svg v-else class="mx-1 w-3 h-3 animate-spin fill-zt-red" viewBox="0 0 100 101">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
          </span>
        </Transition>
       osób/y
      </div>
      <hr v-if="commentaryData.commentaryPlanned && !additional"
          class="border-[#3A4B64] border-b-[1px] -ml-4 xl:-ml-[44px]" :style="'box-shadow: 0px 6px 17px 0px rgba(0, 0, 0, 0.40);'">
      <div ref="commentariesContainer"
           class="pt-4 mb-2 flex flex-col items-stretch space-y-4 overflow-y-auto pr-4 xl:pr-12 xl:space-y-5"
           :class="[{ 'pl-4 xl:pl-5': !additional || (commentaryData.status === 'NS' && fullCommentary) },
                    {'pl-4 xl:!pl-[60px] xl:!pr-12': additional}]">
        <transition-group name="fade" v-if="commentariesToShow.length > 0">
          <div v-if="nextFight" class="bg-zt-light-transparent mt-2 px-4 py-2.5 rounded-zt border-[1px] border-zt-light flex xl:mr-[60px] xl:ml-[24px]">
            <div class="flex flex-col text-xs space-y-1 shrink-1">
              <span class="truncate">
                {{nextFight.competitor_name1}}
              </span>
              <span class="truncate">
                {{nextFight.competitor_name2}}
              </span>
            </div>
            <div class="ml-auto text-center items-center justify-center my-auto text-xs text-zt-more shrink-0">
              <span>NAJBLIŻSZA WALKA</span>
            </div>
          </div>
          <div v-for="(comm, index) in commentariesToShow" :key="comm.id"
               class="commentary relative pl-1
                      last:before:h-[calc(100%_-_8px)] last:before:!translate-y-0
                      xl:pl-2 xl:last:before:!h-[calc(100%_-_14px)]"
               :class="{'before:!h-[calc(100%_-_20px)] before:!-translate-y-[5px]' : additional === 1 && index === 3}">
            <div class="absolute -left-4 content-[''] w-[11px] h-[11px] bg-zt-red rounded-full top-1 border-2
                        border-zt-light xl:top-1 xl:-left-3"></div>
            <div class="text-sm font-light mb-2 text-zt-more">
              <span>{{ getTime(comm.date) }}</span>
              <div v-if="comm.fight_start" class="inline">
                <span class="mx-1">|</span>
                <span class="font-semibold">ZACZYNAMY WALKĘ</span>
              </div>
              <div v-if="comm.is_poll" class="inline">
                <span class="mx-1">|</span>
                <span class="font-semibold">SONDA {{ hasPollEnded(comm.poll.poll) ? '(Zakończona)' : '' }}</span>
              </div>
            </div>
            <div v-if="comm.is_poll">
              <SinglePoll :poll-data="comm.poll.poll" :poll-options="comm.poll.options" @refresh="refreshPoll(comm)" :key="comm.poll.poll.id"/>
            </div>
            <div v-else class="commentary-content text-base font-light leading-[21px] rounded-zt p-2.5
                               max-w-full break-words"
                 :class="{ 'shadow-[#314056] shadow-[0_4px_10px] !bg-[#314056]': commentaryData.newMessagesIds.includes(comm.id),
                           'font-semibold': comm.key_moment,
                           'w-fit bg-zt-light/30': +comm.is_video === 0 }"
                 v-html="comm.content">
            </div>
            <div v-if="additional === 1 && index === 3" class="after:bg-gradient-to-t after:from-[#263042]
             after:to-transparent after:h-full after:absolute after:top-0 after:w-[calc(100%_+_11px)]
             after:-left-[11px] after:xl:-left-[7px] after:xl:w-[calc(100%_+_7px)]"></div>
          </div>
        </transition-group>

        <div v-if="dataLoading"
             class="w-full h-full mt-20 flex flex-col justify-center items-center lg:mt-10">
          <svg class="mr-2 w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
          </svg>
          <span class="mt-4 animate-bounce">Ładowanie relacji</span>
        </div>

        <div v-if="additional && fullCommentary && commentaryData.link && commentaryData.link.length > 0 &&
                   (commentaryData.status === 'IP' || commentaryData.status === 'NS')"
             class="bg-zt-light/35 border border-zt-light rounded-zt flex flex-col items-center px-5 py-3 gap-y-3 mt-4 ml-1
                    xl:flex-row xl:gap-x-6 xl:justify-center xl:ml-2">
          <div class="text-center">
            Śledź relację tekstową <span class="text-zt-red">NA ŻYWO</span> z {{ galaName }}
          </div>
          <a :href="commentaryData.link" class="no-default-style" @click.prevent="handleClick(commentaryData.link)">
            <button class="zt-button">PRZEJDŹ DO RELACJI</button>
          </a>
        </div>
        <div v-else-if="additional && commentaryData.status === 'EN' && fullCommentary"
             class="bg-zt-light/35 border border-zt-light rounded-zt flex flex-col items-center px-5 py-3 gap-y-3 mt-4 ml-1
                    xl:flex-row xl:gap-x-6 xl:justify-center xl:ml-2">
          <div class="text-center">
            Sprawdź pełną relację tekstową z {{ galaName }}
          </div>
          <div class="no-default-style">
            <button class="zt-button" @click.prevent="handleClick(commentaryData.link)">PRZEJDŹ DO RELACJI</button>
          </div>
        </div>
        <div v-if="additional && !fullCommentary"
             class="bg-zt-light/35 border border-zt-light rounded-zt px-5 py-3 text-center w-fit mx-auto mt-4 font-light">
          Po zakończeniu relacji pojawią się kluczowe momenty
        </div>

        <div v-show="loadingIndicator"
             class="absolute z-10 bottom-2 left-1/2 -translate-x-1/2 flex justify-center bg-zt-normal rounded-full p-2">
          <div class="spinner h-8 w-8 border-4" role="status">
            <span class="invisible">Wczytywanie...</span>
          </div>
        </div>

        <div v-if="!additional && !hideShadow"
             class="absolute bottom-0 w-[calc(100%_+_1rem)] -ml-8 h-14 xl:w-full xl:-ml-16
                    after:bg-gradient-to-t after:from-[#263042] after:to-transparent after:h-full after:absolute
                    after:top-0 after:w-full">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import {Notice} from '../../../assets/js/Notice';
import {countClicks} from '../../../assets/js/utils';
import SinglePoll from "../SinglePoll.vue";

export default {
  name: 'Commentaries',
  components: {SinglePoll},
  inject: ['WP'],
  mixins: [utils_mixin],
  props: ['galaId', 'galaName', 'commentaryData', 'additional', 'dataLoading'],
  data() {
    return {
      fullCommentary: true,
      commentaryShowCount: 10,
      loadingIndicator: false,
      hideShadow: false,
      lastRefresh: null,
    }
  },
  computed: {
    commentaries() {
      let commentary = [];
      if (this.commentaryData.status === 'EN') {
        if (this.fullCommentary) {
          commentary = this.commentaryData.commentaryMsgs
              .slice()
              .reverse();
        } else {
          commentary = this.commentaryData.commentaryMsgs
            .filter(msg => msg.key_moment === true)
            .slice()
            .reverse();
        }
      } else {
        if (this.fullCommentary) {
          commentary = this.commentaryData.commentaryMsgs;
        } else {
          commentary = this.commentaryData.commentaryMsgs
            .filter(msg => msg.key_moment === true);
        }
      }
      return commentary;
    },
    commentariesToShow() {
      return this.additional === 1 ? this.commentaries.slice(0, 4) : this.commentaries.slice(0, this.commentaryShowCount);
    },
    keyMomentsCount() {
      return this.commentaryData.commentaryMsgs
          .filter(msg => msg.key_moment === true).length;
    },
    followsNumberWidth() {
      if (this.commentaryData.currentlyFollows * 3 >= 100) {
        return '28px';
      } else if (this.commentaryData.currentlyFollows * 3 >= 10) {
        return '20px';
      } else {
        return '10px';
      }
    },
  },
  updated() {
    this.$nextTick(observeEmbedded);
  },
  mounted() {
    if (this.$refs.commentariesContainer) {
      this.$refs.commentariesContainer.addEventListener('scroll', this.handleScroll, { passive: true });
    }
  },
  methods: {
    refreshPoll(comm) {
      if(this.lastRefresh === null || this.lastRefresh < Date.now() - 5000) {
        axios
            .post(this.WP.ajaxUrl, {
              endpoint: 'api_get_poll_by_id',
              poll_id: comm.poll.poll.id,
            })
            .then((response) => {
              this.lastRefresh = Date.now();
              let index = this.commentaryData.commentaryMsgs.findIndex((el) => {
                return el.id === comm.id;
              })
              if (index !== -1) {
                this.commentaryData.commentaryMsgs[index].poll.options = response.data.data;
              }
            });
      }
    },
    handleScroll(e) {
      if (Math.ceil(e.target.scrollTop) + 5 >= (e.target.scrollHeight - e.target.offsetHeight)) {
        if (this.loadingIndicator) return;
        if (this.commentaryShowCount < this.commentaries.length) {
          this.loadingIndicator = true;
          this.blockScrolling();
        }
        setTimeout(() => { // Specjalnie opóźnione "wczytywanie" komentarzy
          this.loadingIndicator = false;
          this.$nextTick(this.unblockScrolling);
          if (this.commentaryShowCount >= this.commentaries.length) {
            this.hideShadow = true;
          } else {
            this.commentaryShowCount += 20;
          }
        }, 400);
      } else {
        this.hideShadow = false;
      }
    },
    getTime(date) {
      let dateTime = this.DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss');
      let nowDateTime = this.DateTime.now();
      let diff = nowDateTime.diff(dateTime, ['hours', 'minutes', 'seconds']);

      if (diff.hours <= 24) {
        if (diff.hours > 0) {
          return `${diff.hours} godz. temu`;
        } else if (diff.minutes > 0) {
          return `${diff.minutes} min. temu`;
        } else {
          return `Przed chwilą`;
        }
      } else {
        return dateTime.toFormat('HH:mm');
      }
    },
    copyLinkToCommentary() {
      navigator.clipboard.writeText(window.location.href);
      this.addInternalNotification(new Notice()
        .setContent('Skopiowano link do relacji'));
    },
    toggleSound() {
      this.commentaryData.soundEnabled = !this.commentaryData.soundEnabled;

      let notificationContent = (this.commentaryData.soundEnabled ? 'Włączyłeś' : 'Wyłączyłeś')
        + ' powiadomienia. Po odświeżeniu strony ustawienia zostaną zresetowane';
      this.addInternalNotification(new Notice().setContent(notificationContent));

      localStorage.setItem('commentary_sounds', this.commentaryData.soundEnabled);
    },
    handleCount() {
      if (this.commentaryData.soundEnabled) {
        countClicks('Włącz powiadomienia w relacji');
      }
    },
    hasPollEnded(poll) {
      if (poll.end_date) {
        const pollEndDate = DateTime.fromSQL(poll.end_date).ts;
        const currentTime = DateTime.now().ts;
        return currentTime > pollEndDate;
      }
      return false;
    },
    handleClick(link) {
      countClicks('Relacja kopia - BUTTON CZERWONY')
        .then(() => window.location = link);
    },
    getStartDate() {
      if (this.commentaryData.startDateTime.hasSame(DateTime.now(), 'day')) {
        return 'Dziś ' + this.commentaryData.startDateTime.toFormat('(HH:mm)');
      } else if (this.commentaryData.startDateTime.hasSame(DateTime.now().plus({days: 1}), 'day')) {
        return 'Jutro ' + this.commentaryData.startDateTime.toFormat('(HH:mm)');
      } else {
        return this.commentaryData.startDateTime.toFormat('dd.MM.yy (HH:mm)');
      }
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 3000);
              return;
            }
          }
        }
      }
    },
  }
};
</script>
<style scoped>
.commentary a {
    @apply text-sm !important;
}
.commentary:before {
    @apply content-[''] absolute -left-[11px] bottom-0 h-[calc(100%_+_6px)] translate-y-5 w-px bg-zt-red/60
    xl:-left-[7px] xl:h-[calc(100%_+_10px)] xl:translate-y-[24px];
}

.tab-selected {
    @apply text-zt-red relative;
}
.tab-selected:after {
    @apply absolute -bottom-2 left-1/2 -translate-x-1/2 h-[2px] w-3/5 content-[''] bg-zt-red;
}
.commentary-content:deep(p) {
	@apply text-left !important;
}
.commentary-content:deep(blockquote) {
  @apply px-4 py-2.5 mb-0 !important;
}
.commentary-content:deep(div.twitter-tweet) {
  @apply m-0 !important;
}
.commentary-content:deep(iframe.instagram-media) {
  @apply m-0 !important;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all .3s ease;
}

.slide-fade-enter-from{
  transform: translateY(-10px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>